var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"mt-8 mb-2 title"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"pink"}),_c('ul',_vm._l((_vm.listItems),function(listItem,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(listItem)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }